/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_Pos_DeliveryInputs */

const vi_order_channel_pos_delivery = /** @type {(inputs: Order_Channel_Pos_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`POS giao hàng`)
};

/**

* @param {Order_Channel_Pos_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_pos_delivery = /** @type {((inputs?: Order_Channel_Pos_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_Pos_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_pos_delivery(inputs)
});